import { EFeatureFlag } from '@/constant/global/global.constant';

export enum EApiServers {
  VDI1 = 'VDI1',
  VDI2 = 'VDI2',
  INVENTORY = 'INVENTORY',
  ALERTS = 'ALERTS',
  SMARTCOOLERS = 'SMARTCOOLERS',
}

const isLocalServer = () =>
  import.meta.env.VITE_IS_LOCAL_SERVER === EFeatureFlag.ENABLED;

const localBaseUrlMap: Record<EApiServers, () => string> = {
  [EApiServers.VDI1]: () => import.meta.env.VITE_LOCAL_VDI1_URL,
  [EApiServers.VDI2]: () => import.meta.env.VITE_LOCAL_VDI2_URL,
  [EApiServers.INVENTORY]: () => import.meta.env.VITE_LOCAL_INVENTORY_URL,
  [EApiServers.ALERTS]: () => import.meta.env.VITE_LOCAL_ALERTS_URL,
  [EApiServers.SMARTCOOLERS]: () => import.meta.env.VITE_LOCAL_SMARTCOOLERS_URL,
};

const getServerBaseUrl = () => import.meta.env.VITE_SERVER_BASE_URL || 'https://api-dev.cantaloupegateway.io';

const joinServerUrl = (baseUrl: string, path: string) => {
  const normalizedBase = baseUrl.replace(/\/+$/, '');
  const normalizedPath = path.replace(/^\/+/, '');
  return `${normalizedBase}/${normalizedPath}`;
};

const remoteBaseUrlMap: Record<EApiServers, () => string> = {
  [EApiServers.VDI1]: () =>
    joinServerUrl(
      getServerBaseUrl(),
      import.meta.env.VITE_SERVER_VDI_V1_PATH || 'v1/vdi1'
    ),
  [EApiServers.VDI2]: () =>
    joinServerUrl(
      getServerBaseUrl(),
      import.meta.env.VITE_SERVER_VDI_V2_PATH || 'v1/vdi2'
    ),
  [EApiServers.INVENTORY]: () =>
    joinServerUrl(
      getServerBaseUrl(),
      import.meta.env.VITE_SERVER_INVENTORY_PATH || 'v1/inventory'
    ),
  [EApiServers.ALERTS]: () =>
    joinServerUrl(
      getServerBaseUrl(),
      import.meta.env.VITE_SERVER_ALERTS_PATH || 'v1/alerts'
    ),
  [EApiServers.SMARTCOOLERS]: () =>
    joinServerUrl(
      getServerBaseUrl(),
      import.meta.env.VITE_SERVER_SMARTCOOLERS_PATH || 'v1/smartcoolers'
    ),
};

export const getBaseUrl = (server: EApiServers): string => {
  if (isLocalServer()) {
    return localBaseUrlMap[server]() || remoteBaseUrlMap[server]();
  }
  return remoteBaseUrlMap[server]();
};
